import { useMsal } from "@azure/msal-react";
import { Avatar, IconButton, MenuItem, Tooltip } from "@mui/material";
import { client } from "cache/cache";
import { logoutWithMicrosoft } from "features/Authentication/logout";
import { NavItemPopup } from "features/Navbar/NavItemPopup";
import { useGetMeQuery } from "graphql/generated/schema-types";
import { GetInitials } from "helpers/string-helpers";
import { useMemo } from "react";
import { ShowReleaseNotes } from "shared-components/ReleaseNotes";
import { StyledLink } from "shared-components/styled-components";

export function AccountNavItem(): JSX.Element {
  const { data: claimsQuery } = useGetMeQuery({ fetchPolicy: "cache-only" });

  const initials = useMemo(
    () => GetInitials(claimsQuery?.me?.userName ?? ""),
    [claimsQuery?.me],
  );
  // const image = useMemo(
  //   () => claimsQuery?.me?.slackProfilePhoto,
  //   [claimsQuery]
  // );

  const { instance } = useMsal();
  const logout = async () => {
    await logoutWithMicrosoft({
      clearApolloStore: () => client.clearStore(),
      instance: instance,
    });
  };

  return (
    <>
      <NavItemPopup
        id={"account-popup"}
        Button={(props) => (
          <Tooltip title={claimsQuery?.me?.userName ?? "User"}>
            <IconButton {...props} size="large">
              <Avatar alt={`${claimsQuery?.me?.userName}`}>{initials}</Avatar>
            </IconButton>
          </Tooltip>
        )}
      >
        <MenuItem>
          <StyledLink to="/admin-dashboard">
            <div>Admin Dashboard</div>
          </StyledLink>
        </MenuItem>
        <MenuItem>
          <StyledLink to="/generate-otp">
            <div>Generate OTP</div>
          </StyledLink>
        </MenuItem>
        <MenuItem>
          <StyledLink to="/account-settings">
            <div>Account Settings</div>
          </StyledLink>
        </MenuItem>
        <MenuItem onClick={() => ShowReleaseNotes(true)}>
          Release Notes
        </MenuItem>
        <MenuItem onClick={async () => await logout()}>Logout</MenuItem>
      </NavItemPopup>
    </>
  );
}
